import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
// element-ui lang
import elementEnLocale from 'element-ui/lib/locale/lang/en';
// element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';
// element-ui lang
import elementEsLocale from 'element-ui/lib/locale/lang/es';
// element-ui lang
import elementJaLocale from 'element-ui/lib/locale/lang/ja';
import enLocale from './family/en_US';
import zhLocale from './family/zh_CN';
import esLocale from './family/es';
import jaLocale from './family/ja_JP';
import locale from 'element-ui/lib/locale';

Vue.use(VueI18n);

const messages = {
    en: {
        ...enLocale,
        ...elementEnLocale,
    },
    zh: {
        ...zhLocale,
        ...elementZhLocale,
    },
    es: {
        ...esLocale,
        ...elementEsLocale,
    },
    ja: {
        ...jaLocale,
        ...elementJaLocale,
    },
};
export function getLanguage() {
    const chooseLanguage = Cookies.get('language');
    if (chooseLanguage) return chooseLanguage;

    // if has not choose language
    const language = (navigator.language || navigator.browserLanguage).toLowerCase();
    const locales = Object.keys(messages);
    for (const locale of locales) {
        if (language.indexOf(locale) > -1) {
            return locale;
        }
    }
    return 'en';
}
const i18n = new VueI18n({
    // set locale
    // options: en | zh | es
    locale: getLanguage(),
    // set locale messages
    messages,
});
// 这一步是为了实现element组件的多语言切换 想了解更多可以看element-ui/lib/locale 文件里面的源码
locale.i18n((key, value) => i18n.t(key, value));

export default i18n;
